import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useHistory } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import ReleaseDetails from "./ReleaseDetails";

function InwardClearing() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [inward, setInward] = useState(null);
    const [displayModal, setDisplayModal] = useState(false);
    const [roleRowData, setroleRowData] = useState("");
    const [setPosition] = useState("center");

    let history = useHistory();

    const inwardValues = [
        {
            userCode: "1",
            userName: "satti",
            contactNo: "032424234",
            cnic: "424342323",
            remitterName: "adfalk",
            amount: 10000,
            date: "24 / 23 / 2020",
        },
    ];

    useEffect(() => {
        setInward(inwardValues);
    }, []);

    const formik = useFormik({
        initialValues: {
            instrumentNo: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.instrumentNo) {
                errors.instrumentNo = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            // await handlePostRequest(data, "zbiz/nonFin/saveBranchUser");
            // getBranch();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const dialogFuncMap = {
        displayModal: setDisplayModal,
    };

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);

        if (position) {
            setPosition(position);
        }
    };

    const onHide = (name) => {
        setDisplayModal(false);
    };

    const actionTemplate = () => {
        return (
            <div className="Table__Btn">
                <Button label="Release" className=" Btn__Table" onClick={() => onClick("displayModal")} />
                <Button label="Return" className=" Btn__Table" />
            </div>
        );
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Inward Clearing</h1>
                </div>
                <Dialog visible={displayModal} style={{ width: "50vw" }} onHide={() => onHide("displayModal")}>
                    <ReleaseDetails onHide={onHide} roleRowData={roleRowData} />
                </Dialog>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="instrumentNo" className={classNames({ "p-error": isFormFieldValid("instrumentNo") }, "Label__Text")}>
                                    Enter Instrument No.
                                </label>
                                <InputText id="instrumentNo" type="date" name="instrumentNo" value={formik.values.instrumentNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("instrumentNo") }, "Input__Round")} />
                                {getFormErrorMessage("instrumentNo")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button label="Reset" className="Btn__Transparent" />
                        <Button disabled={loading} label="Search" className="Btn__Dark" />
                    </div>
                </form>
            </div>

            <div className="card p-datatable-sm">
                <DataTable header="" value={inward} loading={loading} paginator rows={6} emptyMessage="No data found.">
                    <Column field="userCode" header="Beneficiary Name" />
                    <Column field="userName" header="Beneficiary Address" />
                    <Column field="contactNo" header="Contact Number" />
                    <Column field="remitterName" header="Remitter Name" />
                    <Column field="amount" header="Amount" />
                    <Column field="date" header="Date" />
                    <Column body={actionTemplate} header="Action" />
                </DataTable>
            </div>
            <br />
        </>
    );
}

export default InwardClearing;
